import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import App from "./app/js/App";
import LoginContainer from "./app/js/auth/LoginContainer";

const Root = ({ store }) => (
    <Provider store={store}>
        <Router>
            <Routes>
                <Route path="/login" element={<LoginContainer />} />
                <Route path="/*" element={<App />} />
            </Routes>
        </Router>
    </Provider>
);

Root.propTypes = {
    store: PropTypes.object.isRequired,
};

export default Root;
